import { chakra } from '@chakra-ui/react'
import { SVGProps } from 'react'

export const LoginImageSvgr = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    width="627"
    height="337"
    viewBox="0 0 627 337"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_2446_234607)">
      <path
        d="M283.907 154.436H231.718C219.475 154.436 209.55 165.378 209.55 178.876V308.035C209.55 321.533 219.475 332.475 231.718 332.475H283.907C296.15 332.475 306.075 321.533 306.075 308.035V178.876C306.075 165.378 296.15 154.436 283.907 154.436Z"
        fill="#FFC654"
      />
      <path
        d="M419.653 75.2971H366.571C354.119 75.2971 344.025 86.2988 344.025 99.8699V307.902C344.025 321.473 354.119 332.475 366.571 332.475H419.653C432.105 332.475 442.2 321.473 442.2 307.902V99.8699C442.2 86.2988 432.105 75.2971 419.653 75.2971Z"
        fill="#FFC654"
      />
      <path
        d="M554.507 0H502.317C490.074 0 480.15 11.0062 480.15 24.5832V307.892C480.15 321.469 490.074 332.475 502.317 332.475H554.507C566.75 332.475 576.675 321.469 576.675 307.892V24.5832C576.675 11.0062 566.75 0 554.507 0Z"
        fill="#FFC654"
      />
      <path
        d="M427.09 336.447H443.074C444.896 336.447 446.374 334.97 446.374 333.147V251.842C446.374 250.019 444.896 248.542 443.074 248.542H427.09V336.447Z"
        fill="#101052"
        stroke="#101052"
        stroke-width="1.2375"
      />
      <path
        d="M427.966 248.542H336.6C334.777 248.542 333.3 250.019 333.3 251.842V333.147C333.3 334.97 334.777 336.447 336.6 336.447H427.966V248.542Z"
        fill="#919AAB"
        stroke="#101052"
        stroke-width="1.65"
      />
      <path
        d="M386.769 249.395H374.497V278.413H386.769V249.395Z"
        fill="#E4E8F0"
      />
      <path
        d="M492.085 247.688H510.523C512.346 247.688 513.823 246.211 513.823 244.388V168.972C513.823 167.15 512.346 165.672 510.523 165.672H492.085V247.688Z"
        fill="#101052"
        stroke="#101052"
        stroke-width="1.2375"
      />
      <path
        d="M493.253 165.861H408.432C406.61 165.861 405.132 167.339 405.132 169.161V244.388C405.132 246.211 406.61 247.688 408.432 247.688H493.253V165.861Z"
        fill="#919AAB"
        stroke="#101052"
        stroke-width="1.65"
      />
      <path
        d="M458.572 166.554H442.269V199.184H458.572V166.554Z"
        fill="#E4E8F0"
      />
      <path
        d="M536.09 248.172H445.34C443.517 248.172 442.04 249.65 442.04 251.472V333.147C442.04 334.97 443.517 336.447 445.34 336.447H536.09V248.172Z"
        fill="#919AAB"
        stroke="#101052"
        stroke-width="1.65"
      />
      <path
        d="M498.76 249.395H485.612V278.413H498.76V249.395Z"
        fill="#E4E8F0"
      />
      <path
        d="M529.979 211.288L516.028 237.903L489.595 204.977L485.866 197.172C485.371 196.323 484.01 194.574 483.383 193.823C480.397 190.242 472.559 179.022 471.346 182.017C470.34 184.525 477.319 195.407 477.319 195.407C477.319 195.407 462.024 204.02 475.645 212.278L479.374 218.919L501.814 262.884C507.572 274.904 524.113 276.331 531.852 265.482L557.361 229.694L529.987 211.288H529.979Z"
        fill="#EDA37E"
      />
      <path
        d="M516.028 237.903L529.979 211.288H529.987L557.361 229.694L531.852 265.482C524.113 276.331 507.572 274.904 501.814 262.884L479.374 218.919L489.595 204.977L516.028 237.903Z"
        fill="#6F6FC7"
      />
      <path
        d="M529.978 211.288L518.857 232.499L538.377 256.317L558.515 229.298L529.978 211.297V211.288Z"
        fill="#4F4FAB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M471.742 198.889L473.12 198.905V199.235C473.12 199.351 473.111 203.022 477.36 205.183L477.657 205.332L477.22 206.66L476.741 206.413C471.742 203.872 471.742 199.441 471.742 199.219V198.889Z"
        fill="#101052"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M471.205 202.164L471.271 202.485C471.271 202.485 471.445 203.368 471.989 204.441C472.534 205.505 473.425 206.734 474.852 207.452L475.149 207.6L474.522 208.83L474.225 208.681C472.476 207.79 471.403 206.346 470.768 205.109C470.133 203.88 469.927 202.84 469.91 202.741L469.852 202.419L471.205 202.164Z"
        fill="#101052"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M475.207 196.958L475.232 197.288C475.232 197.329 475.331 198.327 475.949 199.581C476.576 200.868 477.731 202.419 479.876 203.508L480.173 203.657L479.546 204.886L479.249 204.738C474.283 202.213 473.87 197.618 473.854 197.387L473.829 197.057L475.207 196.95V196.958Z"
        fill="#101052"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M475.372 198.831C475.422 198.319 475.702 197.865 476.131 197.593C476.569 197.313 477.097 197.255 477.592 197.428L482.797 199.268C483.466 199.177 485.809 198.987 487.624 200.423C488.952 201.471 489.653 203.104 489.752 205.224L489.769 205.554L488.845 205.596L488.407 206.033L488.374 205.29C488.292 203.517 487.731 202.271 486.774 201.512C485.99 200.893 485.025 200.67 484.233 200.613C483.837 200.58 483.499 200.596 483.251 200.613C483.127 200.621 483.028 200.637 482.962 200.646C482.929 200.646 482.905 200.646 482.888 200.654C482.872 200.654 482.863 200.654 482.863 200.654L482.682 200.687L477.138 198.723C477.047 198.69 476.956 198.707 476.882 198.748C476.808 198.798 476.767 198.872 476.758 198.954C476.717 199.367 476.824 200.027 477.625 200.802C478.441 201.586 479.984 202.485 482.814 203.327L483.127 203.418L482.731 204.746L482.418 204.655C479.448 203.772 477.649 202.774 476.61 201.759C475.562 200.736 475.29 199.705 475.372 198.831Z"
        fill="#101052"
      />
      <path
        d="M544.556 235.428C535.44 235.428 528.056 228.036 528.056 218.928C528.056 209.82 535.448 202.428 544.556 202.428C553.664 202.428 561.056 209.82 561.056 218.928C561.056 228.036 553.664 235.428 544.556 235.428Z"
        fill="#4F4FAB"
      />
      <path
        d="M544.268 204.63L563.012 193.938L606.143 205.868L600.319 259.773L598.867 291.123H521.465L533.956 213.293L544.268 204.63Z"
        fill="#4F4FAB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M531.563 226.443L532.924 226.658L522.67 290.983L521.308 290.769L531.563 226.443Z"
        fill="white"
      />
      <path
        d="M592.572 237.556L580.255 290.546L598.867 291.107L600.319 259.757C600.319 259.757 594.734 244.577 592.572 237.548V237.556Z"
        fill="#101052"
      />
      <path
        d="M522.208 291.115L531.225 337.744H610.013L598.859 291.115H522.208Z"
        fill="#101052"
      />
      <path
        d="M598.693 290.422L610.903 338.437H530.655L521.366 290.422H598.693ZM609.121 337.051L597.612 291.8H523.04L531.785 337.051H609.121Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M571.963 295.397L575.197 301.098C577.309 304.818 581.286 307.137 585.568 307.137H597.258V308.514H585.568C580.791 308.514 576.361 305.932 574.001 301.782L570.767 296.082L571.972 295.397H571.963Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M553.211 303.507L555.166 313.06L562.426 314.834L568.96 337.901L567.615 338.231L561.287 315.981L553.994 314.191L551.858 303.787L553.211 303.507Z"
        fill="white"
      />
      <path
        d="M515.215 236.093L520.189 242.309L518.978 243.278L514.004 237.062L515.215 236.093Z"
        fill="#101052"
      />
      <path
        d="M567.079 252.712H579.834C580.461 252.712 581.047 252.439 581.451 251.953C581.855 251.474 582.02 250.847 581.913 250.228L581.203 250.352C581.278 250.756 581.162 251.169 580.898 251.491C580.634 251.804 580.246 251.986 579.834 251.986H567.079C566.403 251.986 565.834 251.499 565.71 250.839L565 250.963C565.182 251.969 566.056 252.703 567.079 252.703V252.712Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M565.082 251.293C565.371 252.134 566.163 252.712 567.079 252.712H579.833C580.46 252.712 581.046 252.439 581.45 251.953C581.78 251.557 581.954 251.062 581.945 250.558C581.945 250.451 581.929 250.344 581.912 250.237L581.203 250.36C581.277 250.765 581.162 251.177 580.898 251.499C580.634 251.812 580.246 251.994 579.833 251.994H567.079C566.402 251.994 565.833 251.515 565.709 250.847L565 250.971C565.016 251.078 565.049 251.185 565.082 251.293ZM567.211 253.042H567.071C565.891 253.042 564.876 252.2 564.67 251.029L564.612 250.707L565.973 250.468L566.031 250.789C566.122 251.293 566.559 251.664 567.071 251.664H579.825C580.139 251.664 580.436 251.524 580.634 251.284C580.84 251.045 580.922 250.723 580.865 250.418L580.807 250.096L582.168 249.849L582.226 250.171C582.358 250.88 582.16 251.606 581.698 252.167C581.236 252.72 580.551 253.042 579.825 253.042H567.211Z"
        fill="white"
      />
      <path
        d="M597.926 236.302C588.81 236.302 581.426 228.918 581.426 219.802C581.426 210.686 588.818 203.302 597.926 203.302C607.034 203.302 614.426 210.694 614.426 219.802C614.426 228.91 607.034 236.302 597.926 236.302Z"
        fill="#4F4FAB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M469.581 203.195C469.969 200.893 471.487 197.659 476.321 194.796C475.579 193.617 474.061 191.15 472.765 188.609C472.064 187.223 471.421 185.804 471.008 184.566C470.802 183.948 470.653 183.354 470.587 182.834C470.521 182.314 470.53 181.827 470.662 181.431L470.769 181.118L472.081 181.555L471.973 181.869C471.907 182.067 471.899 182.364 471.957 182.768C472.023 183.172 472.147 183.651 472.328 184.187C472.699 185.268 473.277 186.546 473.937 187.858C475.265 190.482 476.923 193.212 477.864 194.656L478.268 195.283L477.616 195.638C473.714 197.783 471.445 200.472 470.934 203.376C470.563 205.505 471.256 207.081 471.289 207.155V207.163C471.313 207.213 471.685 207.939 472.411 208.797C473.17 209.688 474.308 210.694 475.826 211.239L476.14 211.346L475.678 212.649L475.364 212.542C471.759 211.263 470.109 207.914 470.035 207.757C469.985 207.65 469.111 205.777 469.548 203.178L469.581 203.195Z"
        fill="#101052"
      />
      <path
        d="M529.83 211.23C529.83 211.23 534.701 215.236 538.855 217.588C540.11 218.312 541.569 219.038 543.248 219.735C549.573 222.365 559.02 224.524 572.162 223.38C573.42 223.27 574.63 223.127 575.797 222.959C595.111 220.199 611.505 210.446 611.505 210.446C611.505 210.446 607.793 203.394 603.255 201.744C598.718 200.094 594.187 199.722 590.055 195.968C588.207 194.288 585.919 191.683 585.919 191.683L560.922 190.252C560.922 190.252 555.593 193.532 551.833 194.808C545.718 196.882 544.842 196.964 540.477 198.66C536.519 200.198 532.928 205.118 532.928 205.118L529.83 211.23Z"
        fill="#6F6FC7"
      />
      <path
        d="M577.321 193.064L560.201 190.711L551.833 194.808C551.833 194.808 567.077 200.099 577.321 193.064Z"
        fill="#101052"
      />
      <path
        d="M552.518 165.443L551.693 174.93C551.693 186.893 558.208 195.745 569.391 197.281C580.574 198.818 589.989 190.193 591.293 180.706C591.511 179.122 591.673 177.158 591.767 175.084C592.012 170.539 591.872 165.864 591.293 162.968C590.468 158.843 587.055 153.698 580.568 150.287C576.443 148.118 568.738 148.204 565.472 149.581C564.962 149.794 564.452 150.019 563.961 150.287C562.914 150.827 561.928 151.447 561.002 152.154C556.835 155.307 553.285 159.859 552.518 165.443Z"
        fill="#6F6FC7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M574.914 154.123C571.782 151.178 567.988 149.797 565.422 149.427L564.035 150.163C566.385 150.503 571.144 152.277 574.066 155.025C576.968 157.754 579.276 161.946 579.157 168.174L580.394 168.197C580.52 161.612 578.065 157.086 574.914 154.123Z"
        fill="#101052"
      />
      <path
        d="M574.792 253.978L560.007 254.957C558.517 255.055 557.179 254.077 556.819 252.629L549.267 223.083C548.804 221.22 550.139 219.404 552.049 219.277L566.834 218.299C568.324 218.201 569.662 219.179 570.022 220.627L577.575 250.173C578.037 252.036 576.702 253.852 574.792 253.978Z"
        fill="#F5167A"
      />
      <path
        d="M551.557 221.832C551.981 221.25 552.643 220.883 553.368 220.836L566.094 219.993C567.272 219.916 568.34 220.696 568.623 221.844L569.932 227.131L568.589 227.46L567.28 222.172C567.157 221.676 566.696 221.334 566.185 221.368L553.459 222.21C553.146 222.231 552.859 222.391 552.677 222.642C552.495 222.894 552.426 223.221 552.504 223.522L554.184 230.298L552.704 230.669L551.169 223.85C550.999 223.15 551.141 222.413 551.573 221.831L551.557 221.832Z"
        fill="white"
      />
      <path
        d="M554.478 232.217L555.207 235.156L553.869 235.487L553.141 232.548L554.478 232.217Z"
        fill="white"
      />
      <path
        d="M626.116 258.338L614.426 218.458L583.373 227.582L591.598 251.548L586.739 254.081C588.249 249.94 577.54 245.798 577.54 245.798L577.103 248.446C576.955 249.37 576.328 250.138 575.461 250.484L559.399 256.878L559.456 257.068C560.323 260.071 562.113 262.719 564.571 264.641C568.259 267.529 573.795 268.89 578.341 270.004L607.207 278.105C619.021 281.001 629.532 270.012 626.108 258.338H626.116Z"
        fill="#EDA37E"
      />
      <path
        d="M614.426 218.458L626.116 258.338H626.108C629.532 270.012 619.021 281.001 607.207 278.105L578.341 270.004C578.341 270.004 588.249 249.94 586.739 254.081L591.598 251.548L583.373 227.582L614.426 218.458Z"
        fill="#6F6FC7"
      />
      <path
        d="M591.392 251.169C591.68 251.103 594.32 250.492 598.371 250.731C602.199 250.954 608.057 252.018 614.186 255.83L614.467 256.003L614.087 256.614L614.162 256.663L613.766 257.059L613.667 256.985L613.601 257.092L613.46 257.001C607.586 253.355 601.985 252.332 598.322 252.109C594.906 251.911 592.522 252.34 591.845 252.48L591.4 252.579L591.07 251.243L591.392 251.16V251.169Z"
        fill="#101052"
      />
      <path
        d="M561.89 261.415C561.084 260.42 560.376 259.352 559.762 258.239C558.813 256.514 558.111 254.596 557.592 252.678C557.043 250.656 556.499 248.441 557.116 246.364C557.263 245.86 557.648 245.281 558.163 245.392C559.074 245.59 559.675 247.738 559.994 248.468C560.61 249.898 561.18 251.351 561.922 252.722C563.437 255.508 566.065 257.681 567.006 260.707C567.14 261.13 567.232 261.608 567.047 262.017C566.932 262.267 566.733 262.453 566.535 262.639C565.747 263.382 564.834 264.235 563.783 263.515C563.001 262.984 562.476 262.149 561.883 261.424L561.89 261.415Z"
        fill="#EDA37E"
      />
      <path
        d="M564.492 256.619C563.628 255.623 562.87 254.555 562.214 253.439C560.728 250.914 559.578 248.001 559.261 245.08C559.16 244.178 558.707 240.234 560.5 240.6C561.494 240.802 562.201 243.111 562.57 243.901C563.192 245.254 563.777 246.631 564.531 247.916C566.154 250.696 568.966 252.876 569.973 255.901C570.116 256.331 570.215 256.8 570.023 257.21C569.908 257.46 569.685 257.649 569.478 257.836C568.633 258.588 567.651 259.425 566.526 258.708C565.685 258.176 565.126 257.338 564.491 256.61L564.492 256.619Z"
        fill="#EDA37E"
      />
      <path
        d="M567.312 252.783C566.448 251.788 565.69 250.719 565.034 249.603C563.711 247.356 562.793 244.902 562.249 242.388C562.057 241.49 561.305 236.355 563.32 236.765C564.271 236.956 564.915 239.057 565.271 239.815C565.939 241.254 566.553 242.718 567.354 244.097C568.976 246.877 571.788 249.049 572.795 252.082C572.938 252.504 573.038 252.981 572.845 253.391C572.73 253.641 572.507 253.83 572.3 254.017C571.455 254.769 570.473 255.606 569.349 254.897C568.508 254.365 567.949 253.527 567.314 252.8L567.312 252.783Z"
        fill="#EDA37E"
      />
      <path
        d="M571.297 252.392C570.494 251.355 569.797 250.244 569.21 249.085C568.029 246.777 567.246 244.279 566.846 241.719C566.707 240.847 566.202 235.636 568.243 236.167C569.176 236.411 569.721 238.576 570.02 239.342C570.6 240.81 571.126 242.303 571.84 243.711C573.299 246.58 575.983 248.912 576.815 251.994C576.934 252.427 577.001 252.909 576.781 253.298C576.647 253.534 576.423 253.715 576.198 253.897C575.313 254.595 574.282 255.381 573.206 254.599C572.399 254.012 571.887 253.151 571.297 252.392Z"
        fill="#EDA37E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M558.601 245.423L558.571 245.093L559.946 244.976L559.991 245.295C559.991 245.295 560.364 249.208 563.597 254.328L563.777 254.603L562.614 255.34L562.434 255.066C559.011 249.664 558.621 245.628 558.601 245.423Z"
        fill="#101052"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M561.488 242.003L561.466 241.673L562.846 241.588L562.867 241.918C562.873 241.959 563.17 245.808 567.341 251.738L567.529 252.012L566.672 252.615L566.515 252.387L566.288 252.61L565.925 252.336L566.023 252.264C561.793 246.15 561.502 242.226 561.488 242.003Z"
        fill="#101052"
      />
      <path
        d="M565.97 239.751L566.025 239.427L567.399 239.659L567.337 239.993C567.334 240.035 567.275 240.443 567.317 241.162L567.012 239.93L567.319 241.17C567.374 242.22 567.641 243.949 568.544 246.171L568.973 247.927C568.916 247.819 568.867 247.709 568.819 247.599C568.875 247.708 568.916 247.819 568.973 247.927L568.544 246.171C569.013 247.322 569.642 248.6 570.512 249.994L570.685 250.278L569.513 251.009L569.34 250.725C565.3 244.243 565.938 239.997 565.978 239.75L565.97 239.751Z"
        fill="#101052"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M561.111 255.793C561.249 255.59 563.871 252.066 572.104 248.572L572.411 248.446L572.956 249.719L572.649 249.845C564.826 253.173 562.282 256.545 562.232 256.602L561.752 257.277L561.657 256.599L561.582 256.543L560.924 256.069L561.112 255.801L561.111 255.793Z"
        fill="#101052"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M575.844 249.097C575.844 249.097 575.877 249.034 575.902 248.972C575.949 248.833 576.004 248.633 576.043 248.378C576.131 247.874 576.181 246.392 576.172 245.735L576.167 245.403L577.547 245.385L577.552 245.717C577.56 246.191 577.549 247.826 577.421 248.577C577.357 248.952 577.259 249.324 577.11 249.628C576.961 249.932 576.744 250.229 576.412 250.359L576.018 250.514L575.965 250.138L575.592 249.199L575.852 249.096L575.844 249.097Z"
        fill="#101052"
      />
      <path
        d="M582.004 224.15L589.858 246.714L622.388 245.616L613.948 215.834L582.004 224.158V224.15Z"
        fill="#4F4FAB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M577.296 204.311C583.432 202.3 589.618 199.693 592.943 198.03L591.705 197.205C588.43 198.843 582.984 201.145 576.91 203.135C570.823 205.13 564.306 206.648 559.137 206.487C548.755 206.163 541.873 201.211 539.78 198.857L538.493 199.68C540.8 202.276 548.36 207.388 559.099 207.724C564.489 207.892 571.173 206.317 577.296 204.311Z"
        fill="#101052"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M541.098 207.065C538.277 204.691 536.793 202.418 536.43 201.33L535.431 201.939C535.893 203.326 537.389 205.56 540.301 208.012C543.23 210.477 547.626 213.192 553.954 215.524C560.339 217.876 569.512 218.491 578.321 218.325C587.15 218.16 593.537 217.422 598.718 216.593L601.605 215.355C596.474 216.176 587.062 216.924 578.298 217.088C569.514 217.253 560.537 216.63 554.382 214.362C548.17 212.074 543.904 209.427 541.098 207.065Z"
        fill="#101052"
      />
      <path
        d="M579.406 183.87C579.52 181.482 580.071 169.947 580.071 169.947C570.668 169.947 563.655 162.556 563.655 162.556C563.655 162.556 560.728 164.428 551.986 169.994L551.466 180.899C553.295 197.782 571.349 191.463 573.915 189.99C576.481 188.517 579.292 186.258 579.406 183.87Z"
        fill="#EDA37E"
      />
      <path
        d="M559.433 175.073C558.756 176.664 557.624 178.119 554.935 180.93C554.356 181.536 554.69 182.565 555.502 182.678L558.772 182.484C559.696 182.429 560.435 181.663 560.49 180.705L560.765 175.847C560.626 174.568 559.708 174.427 559.431 175.073L559.433 175.073Z"
        fill="#BF714B"
      />
      <path
        d="M566.549 175.713C566.582 176.53 567.026 177.176 567.538 177.154C568.051 177.132 568.442 176.454 568.409 175.637C568.375 174.821 567.932 174.175 567.42 174.197C566.907 174.219 566.516 174.897 566.549 175.713Z"
        fill="#101052"
      />
      <path
        d="M556.079 174.388C555.968 175.198 555.465 175.798 554.957 175.727C554.449 175.657 554.124 174.945 554.235 174.135C554.346 173.325 554.849 172.725 555.357 172.795C555.865 172.866 556.19 173.578 556.079 174.388Z"
        fill="#101052"
      />
      <path
        d="M579.07 173.287C579.07 173.287 583.39 168.657 584.771 172.121C586.153 175.584 586.813 179.373 584.166 180.384C581.521 181.397 578.791 179.458 578.791 179.458L579.069 173.289L579.07 173.287Z"
        fill="#EDA37E"
      />
      <path
        d="M582.633 174.734L580.171 176.128L580.882 177.384L583.345 175.99L582.633 174.734Z"
        fill="#101052"
      />
      <path
        d="M578.367 179.375C577.989 180.205 578.356 181.184 579.186 181.56C580.015 181.938 580.995 181.571 581.371 180.741C581.749 179.911 581.382 178.932 580.552 178.556C579.721 178.18 578.743 178.545 578.367 179.375Z"
        fill="#101052"
      />
      <path
        d="M328.44 181.452L305.137 220.797L283.851 187.82C283.851 187.82 287.023 171.465 284.643 166.104C282.262 160.742 277.463 177.648 277.463 177.648C277.463 177.648 265.285 163.844 259.735 163.658C258.881 163.63 258.192 164.35 258.295 165.209C258.371 165.859 258.774 166.739 259.921 167.847C259.921 167.847 255.115 163.648 253.706 165.255C253.706 165.255 251.55 167.892 257.014 171.333C257.014 171.333 252.525 168.259 251.019 170.641C249.61 172.877 254.523 175.444 254.523 175.444L262.226 180.6C262.226 180.6 262.226 180.628 262.216 180.621C261.268 180.324 252.669 177.683 250.764 179.709C249.293 181.274 254.885 183.628 258.013 184.781C259.225 185.228 260.228 186.115 260.827 187.275C262.198 189.923 261.354 193.087 269.375 200.325L280.84 246.684C285.408 265.162 309.151 269.868 320.248 254.498L357.816 202.466L328.44 181.448V181.452Z"
        fill="#FFCBCB"
      />
      <path
        d="M303.679 216.913L302.237 217.869L307.584 226.16L309.026 225.205L303.679 216.913Z"
        fill="#101052"
      />
      <path
        d="M259.873 166.66L258.776 168.007L267.641 175.429L268.737 174.082L259.873 166.66Z"
        fill="#101052"
      />
      <path
        d="M257.363 170.475L256.266 171.822L265.13 179.244L266.227 177.897L257.363 170.475Z"
        fill="#101052"
      />
      <path
        d="M343.46 209.721C353.394 209.721 361.447 201.556 361.447 191.484C361.447 181.412 353.394 173.247 343.46 173.247C333.526 173.247 325.474 181.412 325.474 191.484C325.474 201.556 333.526 209.721 343.46 209.721Z"
        fill="#3A3A94"
      />
      <path
        d="M263.6 182.081C253.206 178.696 251.484 180.191 251.467 180.208C251.467 180.208 251.512 180.166 251.556 180.058L249.975 179.363C250.375 178.423 252.559 176.649 264.127 180.414L263.6 182.077V182.081Z"
        fill="#101052"
      />
      <path
        d="M328.439 181.452L338.454 272.809H435.632L439.315 186.95L423.647 173.167L390.316 166.582L368.599 167.441L338.22 174.033L328.439 181.452Z"
        fill="#3A3A94"
      />
      <path
        d="M327.633 182.811L308.379 214.908L327.041 245.095L357.819 202.47L327.633 182.811Z"
        fill="#3A3A94"
      />
      <path
        d="M420.556 272.809H435.632L437.082 238.626L417.666 215.677L420.556 272.809Z"
        fill="#101052"
      />
      <path
        d="M338.337 272.808L346.522 336.151H450.26L435.735 272.808H338.337Z"
        fill="#101052"
      />
      <path
        d="M449.423 336.347L435.054 273.682H339.319L347.377 336.036L345.669 336.263L337.355 271.935H436.421L451.101 335.952L449.423 336.347Z"
        fill="#E4E8F0"
      />
      <path
        d="M389 304.48L387.433 336.151H399.687L389 304.48Z"
        fill="#101052"
      />
      <path
        d="M398.874 336.434L388.315 305.144L376.705 300.498L371.237 286.17L372.843 285.541L378.038 299.153L389.686 303.816L400.503 335.868L398.874 336.434Z"
        fill="#E4E8F0"
      />
      <path
        d="M419.319 305.497L417.672 306.009L426.655 335.707L428.302 335.195L419.319 305.497Z"
        fill="#E4E8F0"
      />
      <path
        d="M407.024 204.803L440.786 250.275L415.358 295.43L418.979 299.419L423.592 301.731H437.241L474.069 263.329C480.28 256.853 481.128 246.838 476.094 239.384L435.587 179.381L407.028 204.803H407.024Z"
        fill="#FFCBCB"
      />
      <path
        d="M438.982 197.577C442.35 188.101 437.505 177.651 428.159 174.236C418.814 170.821 408.508 175.734 405.14 185.209C401.771 194.685 406.617 205.135 415.962 208.55C425.307 211.965 435.614 207.052 438.982 197.577Z"
        fill="#3A3A94"
      />
      <path
        d="M405.815 203.863L433.614 240.558L461.959 218.338L435.588 179.381L405.815 203.863Z"
        fill="#3A3A94"
      />
      <path
        d="M335.546 246.293L335.729 247.931H419.299L419.161 246.293H335.546Z"
        fill="#6F6FC7"
      />
      <path
        d="M341.165 173.393C340.156 173.523 339.178 173.739 338.227 174.033H338.22C337.558 174.235 336.911 174.48 336.284 174.759H429.438C427.615 173.907 425.655 173.365 423.65 173.166L423.433 173.121H342.43L341.172 173.393H341.165Z"
        fill="#6F6FC7"
      />
      <path
        d="M310.701 218.663H461.542L461.959 218.338L461.07 217.025H309.688L310.701 218.663Z"
        fill="#6F6FC7"
      />
      <path
        d="M420.04 262.567L419.957 260.929H337.152L337.331 262.567H420.04Z"
        fill="#6F6FC7"
      />
      <path
        d="M324.667 187.757L323.685 189.395H442.364L441.254 187.757H324.667Z"
        fill="#6F6FC7"
      />
      <path
        d="M318.735 231.661L319.748 233.299H418.538V231.661H318.735Z"
        fill="#6F6FC7"
      />
      <path
        d="M427.13 231.661L428.143 233.299H442.874L444.965 231.661H427.13Z"
        fill="#6F6FC7"
      />
      <path
        d="M315.886 202.389L314.904 204.027H452.272L451.162 202.389H315.886Z"
        fill="#6F6FC7"
      />
      <path
        d="M416.768 216.885L415.402 217.948L433.002 241.204L434.368 240.141L416.768 216.885Z"
        fill="#E4E8F0"
      />
      <path
        d="M443.9 243.408L438.461 252.601L439.938 253.499L445.377 244.306L443.9 243.408Z"
        fill="#101052"
      />
      <path
        d="M439.315 302.605H426.183C420.657 302.605 415.768 299.237 413.732 294.029L407.066 276.973L408.668 276.33L415.334 293.386C417.108 297.927 421.366 300.862 426.183 300.862H439.315V302.608V302.605Z"
        fill="#E4E8F0"
      />
      <path
        d="M424.133 279.826L424.626 280.231C425.687 281.29 426.365 282.683 426.548 284.182L426.593 284.559L433.924 276.766L433.476 276.721C431.994 276.574 430.603 275.921 429.531 274.873L427.788 273.147L424.133 279.83V279.826Z"
        fill="#3A3A94"
      />
      <path
        d="M442.113 296.649L441.455 296.051C440.335 295.056 438.912 294.476 437.424 294.406L437.052 294.389L444.166 286.39L444.242 286.84C444.497 288.328 445.244 289.684 446.357 290.69L447.125 291.392L442.113 296.652V296.649Z"
        fill="#3A3A94"
      />
      <path
        d="M443.112 287.63C443.015 287.839 442.884 288.035 442.729 288.209L438.709 292.712C438.289 293.18 437.713 293.456 437.083 293.487C436.452 293.519 435.853 293.302 435.391 292.876L428.222 286.288C427.464 285.593 427.24 284.447 427.678 283.508C427.774 283.298 427.905 283.103 428.06 282.928L432.081 278.429C432.949 277.458 434.437 277.381 435.398 278.265L442.568 284.853C443.325 285.548 443.549 286.693 443.112 287.633V287.63Z"
        fill="#101052"
      />
      <path
        d="M439.126 284.35L431.564 284.416L431.579 286.162L439.141 286.096L439.126 284.35Z"
        fill="#E4E8F0"
      />
      <path
        d="M437.739 286.801L434.204 286.831L434.219 288.578L437.753 288.547L437.739 286.801Z"
        fill="#E4E8F0"
      />
      <path
        d="M376.002 219.355L355.366 170.484L356.947 169.796L376.14 215.247L400.048 167.853L401.582 168.646L376.002 219.355Z"
        fill="#E4E8F0"
      />
      <path
        d="M385.159 215.603H367.241C364.91 215.603 363.021 217.519 363.021 219.882V231.084C363.021 233.447 364.91 235.363 367.241 235.363H385.159C387.49 235.363 389.379 233.447 389.379 231.084V219.882C389.379 217.519 387.49 215.603 385.159 215.603Z"
        fill="#E4E8F0"
      />
      <path
        d="M370.418 218.38H367.975C366.952 218.38 366.122 219.221 366.122 220.259V222.736C366.122 223.774 366.952 224.615 367.975 224.615H370.418C371.441 224.615 372.271 223.774 372.271 222.736V220.259C372.271 219.221 371.441 218.38 370.418 218.38Z"
        fill="#3A3A94"
      />
      <path
        d="M389.379 226.383H363.021V230.805H389.379V226.383Z"
        fill="#2A2A7D"
      />
      <path
        d="M274.084 188.815L274.032 188.7C272.189 184.679 273.329 179.852 276.74 177.113L279.458 169.331L281.081 169.914L278.19 178.189L277.98 178.346C275.055 180.561 274.053 184.606 275.593 187.963L275.644 188.078L274.084 188.815Z"
        fill="#101052"
      />
      <path
        d="M334.737 234.438L333.349 220.123L327.041 245.095L334.737 234.438Z"
        fill="#101052"
      />
      <path
        d="M333.955 217.546L332.241 217.717L337.596 272.994L339.311 272.823L333.955 217.546Z"
        fill="#E4E8F0"
      />
      <path
        d="M364.23 140.758C364.23 140.758 368.822 163.882 367.344 174.379C365.866 184.875 376.808 184.575 376.808 184.575C376.808 184.575 398.105 184.274 388.934 166.582C388.934 166.582 383.016 151.855 383.384 140.758H364.23Z"
        fill="#FFCBCB"
      />
      <path
        d="M365.97 151.01L367.207 161.122C372.981 159.683 377.618 155.327 379.467 149.599L381.069 144.639L365.97 151.01Z"
        fill="#101052"
      />
      <path
        d="M368.984 152.295C363.39 153.839 357.13 152.282 357.705 146.081C358.587 136.566 359.848 125.497 361.264 120.586C363.999 111.123 376.994 117.823 376.994 117.823C376.994 117.823 385.596 135.567 383.381 140.758C379.512 149.826 368.981 152.295 368.981 152.295H368.984Z"
        fill="#FFCBCB"
      />
      <path
        d="M366.88 124.107C366.973 124.788 366.707 125.392 366.287 125.452C365.863 125.511 365.447 125.008 365.35 124.327C365.257 123.646 365.522 123.041 365.943 122.982C366.363 122.923 366.783 123.426 366.88 124.107Z"
        fill="#101052"
      />
      <path
        d="M361.35 124.537C361.226 124.163 360.73 124.103 360.523 124.439C360.523 124.439 359.042 126.583 357.078 131.177C356.74 131.963 357.361 132.794 358.156 132.511L361.408 131.355C362.556 130.946 363.169 129.678 362.783 128.508L361.35 124.537Z"
        fill="#EB8D90"
      />
      <path
        d="M383.519 140.374C383.54 140.304 383.56 140.231 383.578 140.157C383.588 140.119 383.595 140.081 383.605 140.042C383.622 139.969 383.636 139.892 383.65 139.815C383.657 139.777 383.664 139.742 383.671 139.703C383.684 139.609 383.698 139.515 383.708 139.417C383.708 139.392 383.715 139.372 383.715 139.347C383.726 139.221 383.736 139.096 383.743 138.963C383.743 138.942 383.743 138.917 383.743 138.896C383.746 138.788 383.75 138.676 383.75 138.565C383.75 138.526 383.75 138.488 383.75 138.449C383.75 138.345 383.75 138.243 383.743 138.135C383.743 138.097 383.743 138.058 383.739 138.02C383.733 137.901 383.726 137.782 383.719 137.66C383.719 137.635 383.719 137.611 383.712 137.583C383.688 137.276 383.653 136.958 383.609 136.629C383.609 136.612 383.605 136.598 383.602 136.581C383.581 136.434 383.56 136.284 383.536 136.133C383.533 136.109 383.529 136.085 383.526 136.06C383.502 135.906 383.474 135.753 383.447 135.599C383.447 135.585 383.443 135.571 383.44 135.557C383.309 134.848 383.14 134.104 382.944 133.343C382.634 133.262 382.289 133.266 381.972 133.329C381.393 133.444 380.842 133.699 380.257 133.744C379.268 133.821 378.293 133.259 377.721 132.438C377.149 131.617 376.949 130.569 377.018 129.567C377.018 129.574 375.172 129.521 374.903 129.724C373.949 130.447 373.801 132.888 373.366 133.982C373.136 134.565 372.86 135.166 372.367 135.554C371.833 135.98 371.12 136.092 370.442 136.123C369.422 136.172 368.392 136.078 367.396 135.84C366.37 135.596 365.381 135.201 364.347 134.977C362.745 134.631 361.088 134.708 359.455 134.785C359.269 134.792 359.08 134.806 358.89 134.824C358.449 138.512 358.053 142.41 357.716 146.078C357.557 147.769 357.912 149.114 358.622 150.148C358.739 150.308 358.859 150.465 358.987 150.619C360.847 152.736 364.416 153.26 367.916 152.551C367.937 152.547 367.958 152.544 367.975 152.54C368.037 152.526 368.099 152.516 368.161 152.502C368.209 152.491 368.261 152.481 368.309 152.467C368.35 152.456 368.392 152.449 368.433 152.439C368.498 152.421 368.564 152.408 368.633 152.39C368.66 152.383 368.688 152.376 368.716 152.369C368.809 152.345 368.902 152.32 368.995 152.296C368.995 152.296 375.947 150.664 380.629 145.191C381.71 143.926 382.668 142.459 383.395 140.758C383.433 140.667 383.467 140.57 383.502 140.472C383.512 140.44 383.522 140.409 383.529 140.378L383.519 140.374Z"
        fill="#AA8095"
      />
      <path
        d="M385.418 141.222C386.038 140.929 386.551 140.332 386.858 139.693C388.046 137.23 387.092 134.257 387.615 131.568C387.981 129.699 389.062 127.813 388.449 126.01C387.991 124.669 386.671 123.747 386.289 122.381C386.01 121.372 386.289 120.303 386.444 119.269C386.599 118.231 386.582 117.047 385.862 116.296C384.884 115.273 383.061 115.514 382.11 114.462C381.194 113.449 381.525 111.71 380.632 110.676C379.654 109.537 377.835 109.883 376.471 110.494C375.11 111.109 373.608 111.912 372.213 111.381C371.1 110.962 370.431 109.81 369.429 109.163C368.199 108.37 366.477 108.461 365.336 109.383C364.282 110.236 363.731 111.671 362.532 112.293C361.302 112.929 359.79 112.496 358.46 112.863C357.178 113.215 356.169 114.326 355.773 115.612C354.87 118.549 357.53 123.516 361.016 121.379C362.194 120.655 363.056 119.14 364.434 119.202C365.44 119.244 366.173 120.142 367.066 120.61C368.075 121.141 369.36 121.096 370.332 120.491C370.886 120.146 371.575 119.622 372.096 120.02C372.316 120.187 372.409 120.47 372.488 120.739C373.225 123.251 373.691 125.846 373.863 128.462C373.914 129.234 373.949 130.038 374.287 130.733C374.624 131.428 375.368 131.99 376.116 131.844C377.125 131.645 377.528 130.373 377.446 129.336C377.363 128.281 376.984 127.271 376.87 126.22C376.757 125.168 376.977 123.974 377.818 123.349C379.01 128.452 380.205 133.566 381.917 138.512C382.369 139.818 383.133 141.331 384.498 141.411C384.818 141.429 385.121 141.359 385.404 141.226L385.418 141.222Z"
        fill="#101052"
      />
      <path
        d="M376.491 124.732C376.491 124.732 378.596 119.402 381.527 122.79C384.459 126.178 386.709 130.227 384.121 132.434C381.538 134.642 377.69 133.528 377.69 133.528L376.491 124.736V124.732Z"
        fill="#FFCBCB"
      />
      <path
        d="M380.801 126.705L378.351 128.104L379.196 129.626L381.646 128.227L380.801 126.705Z"
        fill="#101052"
      />
      <path
        d="M265.657 251.539L295.701 286.373L356.671 291.606V315.569L282.638 314.986C280.695 314.971 278.823 314.258 277.365 312.976L239.776 279.966L265.659 251.539H265.657Z"
        fill="#FFCBCB"
      />
      <path
        d="M270.695 269.375C273.16 258.928 266.69 248.46 256.243 245.994C245.796 243.528 235.328 249.998 232.863 260.446C230.397 270.893 236.867 281.36 247.314 283.826C257.761 286.292 268.229 279.822 270.695 269.375Z"
        fill="#3A3A94"
      />
      <path
        d="M257.234 246.257L261.903 281.569V335.513H184.633L182.199 275.098L191.919 246.74L214.389 239.056H231.908L257.234 246.257Z"
        fill="#3A3A94"
      />
      <path
        d="M183.493 312.641C183.47 312.034 205.652 287.283 205.652 287.283V312.73L183.493 312.641Z"
        fill="#101052"
      />
      <path
        d="M250.056 322.84C250.056 322.84 256.298 310.906 261.58 315.202C266.861 319.499 270.73 326.411 267.759 326.683C264.788 326.954 259.853 321.612 259.853 321.612L255.675 326.729L250.056 322.837V322.84Z"
        fill="#FFCBCB"
      />
      <path
        d="M182.292 254.625L142.378 306.476C133.247 318.335 141.702 335.513 156.671 335.513H264.707C267.56 335.513 268.824 331.924 266.601 330.136L252.654 318.907L242.811 315.566C237.922 313.908 232.803 313.039 227.643 312.999L183.493 312.641L213.777 277.249L182.292 254.625Z"
        fill="#FFCBCB"
      />
      <path
        d="M243.795 328.208H299.059V335.51H247.668C245.531 335.51 243.795 333.775 243.795 331.638V328.208Z"
        fill="#6D7787"
      />
      <path
        d="M356.985 335.51H275.295L292.274 290.549C293.815 286.463 297.728 283.76 302.094 283.76H368.296C372.275 283.76 375.026 287.739 373.62 291.461L356.985 335.51Z"
        fill="#6D7787"
      />
      <path
        d="M363.527 302.702L361.913 306.975L363.263 307.485L364.877 303.212L363.527 302.702Z"
        fill="#E4E8F0"
      />
      <path
        d="M282.326 333.33L280.975 332.819L295.767 293.647C297.208 289.83 300.919 287.266 304.999 287.266H362.674C364.539 287.266 366.286 288.181 367.346 289.714C368.405 291.247 368.645 293.205 367.987 294.949L365.838 300.638L364.487 300.127L366.635 294.438C367.135 293.119 366.959 291.695 366.156 290.534C365.353 289.374 364.083 288.706 362.671 288.706H304.996C301.513 288.706 298.346 290.895 297.116 294.155L282.323 333.327L282.326 333.33Z"
        fill="#E4E8F0"
      />
      <path
        d="M326.002 315.178C328.592 314.894 330.461 312.564 330.177 309.973C329.893 307.383 327.563 305.514 324.973 305.798C322.383 306.082 320.513 308.412 320.797 311.002C321.081 313.593 323.412 315.462 326.002 315.178Z"
        fill="#E4E8F0"
      />
      <path
        d="M218.018 268.071C219.738 257.476 212.543 247.493 201.948 245.773C191.352 244.053 181.369 251.248 179.649 261.843C177.929 272.439 185.124 282.422 195.719 284.142C206.315 285.862 216.298 278.667 218.018 268.071Z"
        fill="#3A3A94"
      />
      <path
        d="M183.707 252.653L155.138 289.896L183.493 312.641L216.425 274.956L183.707 252.653Z"
        fill="#3A3A94"
      />
      <path
        d="M206.283 285.341L182.899 312.108L183.987 313.058L207.37 286.291L206.283 285.341Z"
        fill="#E4E8F0"
      />
      <path
        d="M178.188 311.784L178.165 313.228L190.773 313.433L190.796 311.989L178.188 311.784Z"
        fill="#101052"
      />
      <path
        d="M265.252 250.866L292.112 282.212L272 308.266L245.063 285.88L265.252 250.866Z"
        fill="#3A3A94"
      />
      <path
        d="M261.903 299.875L262.024 284.372L272 308.266L261.903 299.875Z"
        fill="#101052"
      />
      <path
        d="M262.625 281.568H261.181V313.735H262.625V281.568Z"
        fill="#E4E8F0"
      />
      <path
        d="M267.346 327.503C266.231 327.503 264.048 326.651 259.913 322.681L258.891 323.934L257.774 323.021L259.798 320.544L260.364 321.101C265.766 326.432 267.435 326.042 267.453 326.039C267.453 326.039 267.412 326.05 267.343 326.099L268.186 327.272C268.022 327.39 267.759 327.503 267.352 327.503H267.346Z"
        fill="#101052"
      />
      <path
        d="M260.179 322.932C258.92 321.783 257.825 320.489 257.779 320.434L258.882 319.505C258.882 319.505 259.965 320.784 261.152 321.866L260.179 322.932Z"
        fill="#101052"
      />
      <path
        d="M265.044 329.81L257.159 323.46C253.757 320.723 249.949 318.63 245.843 317.241C241.765 315.863 238.684 314.989 236.935 314.711L237.16 313.285C239.017 313.577 242.095 314.449 246.307 315.872C250.578 317.316 254.534 319.49 258.068 322.337L265.954 328.687L265.05 329.81H265.044Z"
        fill="#101052"
      />
      <path
        d="M258.903 329.747C258.172 328.987 256.642 327.748 255.654 327.67L255.77 326.232C257.624 326.383 259.711 328.508 259.942 328.75L258.9 329.749L258.903 329.747Z"
        fill="#101052"
      />
      <path
        d="M237.021 284.442L206.295 242.047L207.465 241.198L236.201 280.852L243.085 242.76L244.506 243.017L237.021 284.442Z"
        fill="#E4E8F0"
      />
      <path
        d="M246.291 279.091H226.933C224.979 279.091 223.396 280.675 223.396 282.628V295.096C223.396 297.05 224.979 298.634 226.933 298.634H246.291C248.244 298.634 249.828 297.05 249.828 295.096V282.628C249.828 280.675 248.244 279.091 246.291 279.091Z"
        fill="#E4E8F0"
      />
      <path
        d="M231.114 281.834H228.056C227.198 281.834 226.502 282.53 226.502 283.388V286.446C226.502 287.304 227.198 287.999 228.056 287.999H231.114C231.972 287.999 232.667 287.304 232.667 286.446V283.388C232.667 282.53 231.972 281.834 231.114 281.834Z"
        fill="#3A3A94"
      />
      <path
        d="M249.828 289.752H223.396V294.126H249.828V289.752Z"
        fill="#2A2A7D"
      />
      <path
        d="M235.424 221.136C235.424 221.136 236.571 239.971 237.662 250.103C238.433 257.259 231.893 257.657 231.893 257.657C231.893 257.657 215.088 258.962 218.411 247.975C218.83 246.586 219.194 245.183 219.448 243.757C220.36 238.614 223.086 228.118 222.315 222.487L235.43 221.136H235.424Z"
        fill="#FFCBCB"
      />
      <path
        d="M228.555 228.45L235.898 228.895L236.611 238.455C236.611 238.455 229.664 234.702 228.555 228.447V228.45Z"
        fill="#101052"
      />
      <path
        d="M220.251 227.815C220.251 227.815 240.252 232.146 244.35 224.809C247.263 219.594 240.154 206.644 235.797 199.59C233.66 196.127 230.054 193.835 226.011 193.393C220.701 192.813 213.306 194.199 214.513 201.983C216.535 215.026 220.251 227.812 220.251 227.812V227.815Z"
        fill="#FFCBCB"
      />
      <path
        d="M239.008 205.645C240.348 207.12 242.153 208.278 246.201 210.319C247.076 210.761 247.07 212.009 246.192 212.442L242.433 213.473C241.37 213.764 240.258 213.21 239.851 212.188L237.784 206.999C237.478 205.552 238.465 205.047 239.011 205.647L239.008 205.645Z"
        fill="#EB8D90"
      />
      <path
        d="M234.281 207.865C234.497 208.572 234.316 209.257 233.871 209.392C233.426 209.528 232.892 209.066 232.673 208.359C232.453 207.651 232.638 206.967 233.083 206.831C233.527 206.696 234.061 207.158 234.281 207.865Z"
        fill="#101052"
      />
      <path
        d="M238.419 181.517C236.109 178.586 233.008 176.155 229.387 175.251C225.766 174.347 221.61 175.179 219.026 177.87C217.467 179.495 216.572 181.644 215.177 183.414C212.073 187.344 206.956 188.926 202.429 191.068C197.901 193.211 193.264 196.887 193.174 201.894C193.068 207.741 199.258 212.439 198.727 218.263C198.282 223.14 193.457 226.195 190.388 230.012C185.445 236.163 185.107 245.457 189.198 252.206C193.287 258.954 201.361 262.921 209.241 262.528C217.121 262.136 224.573 257.596 228.971 251.048C230.022 249.48 230.92 247.791 231.414 245.969C232.875 240.58 230.622 234.829 227.4 230.269C226.225 228.606 225.127 226.917 223.453 225.744C221.983 224.717 220.323 223.868 219.24 222.392C218.166 220.925 217.865 218.944 218.374 217.206C218.893 215.43 220.129 214.065 219.393 212.066C218.827 210.53 217.718 209.294 216.924 207.882C216.621 207.345 216.361 206.756 216.373 206.141C216.384 205.526 216.722 204.879 217.305 204.68C217.79 204.513 218.322 204.68 218.807 204.842C220.427 205.388 222.055 205.252 223.759 205.263C226.337 205.281 228.925 205.102 231.425 204.446C235.748 203.311 239.865 200.548 241.554 196.413C243.564 191.49 241.713 185.695 238.419 181.52V181.517Z"
        fill="#101052"
      />
      <path
        d="M221.524 212.745C221.524 212.745 216.843 207.732 215.327 211.486C213.812 215.237 213.081 219.343 215.954 220.437C218.83 221.532 221.804 219.429 221.804 219.429L221.524 212.748V212.745Z"
        fill="#FFCBCB"
      />
      <path
        d="M217.215 214.561L216.962 215.983L219.481 216.432L219.734 215.011L217.215 214.561Z"
        fill="#101052"
      />
      <path
        d="M222.442 219.314C222.904 220.33 222.451 221.529 221.434 221.988C220.418 222.45 219.22 221.996 218.761 220.98C218.299 219.964 218.752 218.765 219.768 218.306C220.785 217.844 221.983 218.298 222.442 219.314Z"
        fill="#F5167A"
      />
      <path
        d="M174.543 101.475H147.773C143.163 101.475 139.425 105.212 139.425 109.823V136.593C139.425 141.203 143.163 144.941 147.773 144.941H174.543C179.153 144.941 182.891 141.203 182.891 136.593V109.823C182.891 105.212 179.153 101.475 174.543 101.475Z"
        fill="#2A2A7D"
      />
      <path
        d="M167.194 113.351L158.532 122.014L154.827 118.309C154.307 117.789 153.461 117.789 152.941 118.309L149.245 122.005C148.726 122.525 148.726 123.371 149.245 123.891L157.498 132.143C158.067 132.712 158.993 132.712 159.562 132.143L172.776 118.93C173.295 118.41 173.295 117.564 172.776 117.044L169.08 113.348C168.56 112.829 167.714 112.829 167.194 113.348V113.351Z"
        fill="white"
      />
      <path
        d="M377.622 65.4236H344.069C339.042 65.4236 334.95 61.332 334.95 56.3049V22.7521C334.95 17.725 339.042 13.6334 344.069 13.6334H377.622C382.652 13.6334 386.74 17.725 386.74 22.7521V56.3049C386.74 61.332 382.649 65.4236 377.622 65.4236ZM344.069 15.0743C339.836 15.0743 336.394 18.5162 336.394 22.7493V56.302C336.394 60.5351 339.836 63.977 344.069 63.977H377.622C381.855 63.977 385.297 60.5351 385.297 56.302V22.7493C385.297 18.5162 381.855 15.0743 377.622 15.0743H344.069Z"
        fill="#2A2A7D"
      />
      <path
        d="M386.021 24.1583H335.672V25.6021H386.021V24.1583Z"
        fill="#2A2A7D"
      />
      <path
        d="M348.715 29.7773H342.365V36.127H348.715V29.7773Z"
        fill="#F5167A"
      />
      <path
        d="M363.822 29.7773H357.473V36.127H363.822V29.7773Z"
        fill="#F5167A"
      />
      <path d="M378.93 29.7773H372.58V36.127H378.93V29.7773Z" fill="#F5167A" />
      <path
        d="M348.715 41.3274H342.365V47.677H348.715V41.3274Z"
        fill="#F5167A"
      />
      <path
        d="M363.822 41.3274H357.473V47.677H363.822V41.3274Z"
        fill="#F5167A"
      />
      <path d="M378.93 41.3274H372.58V47.677H378.93V41.3274Z" fill="#F5167A" />
      <path
        d="M348.715 52.8774H342.365V59.2271H348.715V52.8774Z"
        fill="#F5167A"
      />
      <path
        d="M363.822 52.8774H357.473V59.2271H363.822V52.8774Z"
        fill="#F5167A"
      />
      <path d="M378.93 52.8774H372.58V59.2271H378.93V52.8774Z" fill="#F5167A" />
      <path
        d="M394.915 36.8518H393.182V38.2956H394.915V36.8518Z"
        fill="#2A2A7D"
      />
      <path
        d="M452.422 38.2956H448.827V36.8518H452.422V38.2956ZM445.235 38.2956H441.64V36.8518H445.235V38.2956ZM438.045 38.2956H434.45V36.8518H438.045V38.2956ZM430.858 38.2956H427.263V36.8518H430.858V38.2956ZM423.669 38.2956H420.074V36.8518H423.669V38.2956ZM416.481 38.2956H412.887V36.8518H416.481V38.2956ZM409.294 38.2956H405.7V36.8518H409.294V38.2956ZM402.105 38.2956H398.51V36.8518H402.105V38.2956Z"
        fill="#2A2A7D"
      />
      <path
        d="M458.469 39.3062H457.025V38.2956H456.014V36.8518H458.469V39.3062Z"
        fill="#2A2A7D"
      />
      <path
        d="M458.469 73.0495H457.025V69.674H458.469V73.0495ZM458.469 66.3014H457.025V62.9259H458.469V66.3014ZM458.469 59.5533H457.025V56.1778H458.469V59.5533ZM458.469 52.8052H457.025V49.4297H458.469V52.8052ZM458.469 46.0571H457.025V42.6816H458.469V46.0571Z"
        fill="#2A2A7D"
      />
      <path
        d="M459.479 78.8765H457.025V76.4221H458.469V77.4327H459.479V78.8765Z"
        fill="#2A2A7D"
      />
      <path
        d="M479.694 78.8765H476.325V77.4327H479.694V78.8765ZM472.958 78.8765H469.588V77.4327H472.958V78.8765ZM466.221 78.8765H462.852V77.4327H466.221V78.8765Z"
        fill="#2A2A7D"
      />
      <path
        d="M484.794 77.4327H483.062V78.8765H484.794V77.4327Z"
        fill="#2A2A7D"
      />
      <path
        d="M519.486 94.4592H499.798C495.788 94.4592 492.525 91.1963 492.525 87.1856V67.4986C492.525 63.4879 495.788 60.225 499.798 60.225H519.486C523.496 60.225 526.759 63.4879 526.759 67.4986V87.1856C526.759 91.1963 523.496 94.4592 519.486 94.4592ZM499.798 61.6687C496.585 61.6687 493.969 64.2848 493.969 67.4986V87.1856C493.969 90.3993 496.585 93.0154 499.798 93.0154H519.486C522.699 93.0154 525.315 90.3993 525.315 87.1856V67.4986C525.315 64.2848 522.699 61.6687 519.486 61.6687H499.798Z"
        fill="#2A2A7D"
      />
      <path
        d="M517.014 74.9714C517.014 70.9001 513.713 67.6025 509.645 67.6025C505.576 67.6025 502.276 70.903 502.276 74.9714C502.276 76.7761 502.926 78.4306 504.003 79.7098L509.648 87.0845L515.192 79.8253C516.326 78.5288 517.017 76.831 517.017 74.9714H517.014ZM509.645 73.0686C510.696 73.0686 511.548 73.9204 511.548 74.9714C511.548 76.0225 510.696 76.8743 509.645 76.8743C508.594 76.8743 507.742 76.0225 507.742 74.9714C507.742 73.9204 508.594 73.0686 509.645 73.0686Z"
        fill="#F5167A"
      />
      <path
        d="M435.787 60.225H412.037C408.192 60.225 405.075 63.3419 405.075 67.1867V90.9364C405.075 94.7813 408.192 97.8982 412.037 97.8982H435.787C439.631 97.8982 442.748 94.7813 442.748 90.9364V67.1867C442.748 63.3419 439.631 60.225 435.787 60.225Z"
        fill="#F5167A"
      />
      <path
        d="M416.365 79.9379H412.701C411.841 79.9379 411.145 80.6347 411.145 81.4942V86.3568C411.145 87.2163 411.841 87.9131 412.701 87.9131H416.365C417.225 87.9131 417.922 87.2163 417.922 86.3568V81.4942C417.922 80.6347 417.225 79.9379 416.365 79.9379Z"
        fill="white"
      />
      <path
        d="M425.747 74.9685H422.083C421.223 74.9685 420.526 75.6653 420.526 76.5249V86.3568C420.526 87.2164 421.223 87.9132 422.083 87.9132H425.747C426.606 87.9132 427.303 87.2164 427.303 86.3568V76.5249C427.303 75.6653 426.606 74.9685 425.747 74.9685Z"
        fill="white"
      />
      <path
        d="M435.125 70.207H431.461C430.602 70.207 429.905 70.9038 429.905 71.7634V86.3568C429.905 87.2164 430.602 87.9132 431.461 87.9132H435.125C435.985 87.9132 436.682 87.2164 436.682 86.3568V71.7634C436.682 70.9038 435.985 70.207 435.125 70.207Z"
        fill="white"
      />
      <path
        d="M298.786 109.63C304.377 104.996 307.937 97.9994 307.937 90.1685C307.937 76.2132 296.624 64.9 282.668 64.9C268.713 64.9 257.4 76.2132 257.4 90.1685C257.4 104.124 268.713 115.437 282.668 115.437C285.85 115.437 288.894 114.848 291.698 113.774C300.126 120.256 306.603 118.486 306.603 118.486C302.563 115.584 300.158 112.183 298.789 109.627L298.786 109.63Z"
        fill="#F5167A"
      />
      <path
        d="M285.839 95.7241H280.197V92.9405C280.197 91.927 280.327 91.1647 280.587 90.6565C280.847 90.1483 281.399 89.4639 282.239 88.5977L284.762 85.9989C285.135 85.5543 285.32 84.9797 285.32 84.2722C285.32 83.5648 285.12 82.9786 284.725 82.508C284.329 82.0373 283.81 81.8034 283.166 81.8034C282.522 81.8034 281.985 82.0806 281.552 82.6379C281.118 83.1952 280.853 83.9315 280.755 84.8468H274.853C275.124 82.3722 276.028 80.429 277.561 79.0199C279.094 77.6108 281.017 76.9033 283.333 76.9033C285.649 76.9033 287.529 77.5357 288.975 78.7975C290.422 80.0594 291.147 81.8034 291.147 84.0297C291.147 85.0201 291.023 85.7564 290.774 86.2386C290.526 86.7208 290.353 87.0673 290.254 87.2781C290.156 87.4889 289.925 87.8036 289.567 88.2252C289.209 88.6468 288.967 88.9182 288.842 89.0424C288.248 89.6372 287.685 90.1916 287.153 90.7113C286.622 91.2311 286.27 91.6584 286.096 91.9905C285.923 92.3255 285.837 92.825 285.837 93.4949V95.7212L285.839 95.7241ZM280.772 102.796C280.14 102.163 279.825 101.392 279.825 100.477C279.825 99.5615 280.14 98.7877 280.772 98.1582C281.404 97.5258 282.175 97.2111 283.091 97.2111C284.006 97.2111 284.78 97.5258 285.409 98.1582C286.042 98.7906 286.356 99.5615 286.356 100.477C286.356 101.392 286.042 102.166 285.409 102.796C284.777 103.428 284.006 103.743 283.091 103.743C282.175 103.743 281.401 103.428 280.772 102.796Z"
        fill="white"
      />
      <path
        d="M127.28 200.018L146.344 238.246L156.716 216.549C156.716 216.549 158.123 183.744 161.346 180.702C164.569 177.659 167.076 198.069 167.076 198.069C167.076 198.069 184.443 192.697 185.34 195.562C186.234 198.427 185.34 201.827 185.34 201.827C185.34 201.827 189.537 205.292 185.737 208.483C185.737 208.483 188.602 210.6 187.327 212.926C187.327 212.926 189.457 218.833 179.252 219.549L162.065 268.305C156.426 284.304 134.616 286.311 126.147 271.612L95.7817 218.894L127.283 200.011L127.28 200.018Z"
        fill="#FFCBCB"
      />
      <path
        d="M127.186 199.827L143.663 232.871L115.74 254.361L95.1624 219.117L127.186 199.827Z"
        fill="#101052"
      />
      <path
        d="M145.918 235.664L144.457 236.348L149.535 247.187L150.996 246.503L145.918 235.664Z"
        fill="#101052"
      />
      <path
        d="M173.69 206.518C173.39 206.518 173.09 206.512 172.783 206.496C171.528 206.431 169.831 206.199 169.551 204.918C169.131 202.986 173.135 200.582 175.561 199.324L176.306 200.756C173.738 202.092 171.338 203.86 171.141 204.547C171.26 204.628 171.677 204.825 172.864 204.886C179.536 205.221 184.788 201.234 184.84 201.195L185.827 202.469C185.604 202.64 180.52 206.522 173.687 206.522L173.69 206.518Z"
        fill="#101052"
      />
      <path
        d="M175.919 211.661C174.125 211.661 172.277 211.384 170.538 210.642C169.573 210.229 169.373 209.545 169.341 209.174C169.189 207.483 171.87 205.583 172.696 205.041L173.583 206.389C172.067 207.386 170.905 208.648 170.95 209.028C170.95 209.028 170.999 209.083 171.176 209.158C177.245 211.751 185.298 207.806 185.378 207.767L186.098 209.209C185.833 209.341 181.107 211.661 175.925 211.661H175.919Z"
        fill="#101052"
      />
      <path
        d="M173.664 216.562C172.212 216.562 171.632 216.249 171.306 215.884C170.87 215.397 170.664 214.787 170.715 214.126C170.854 212.261 173.006 210.429 173.251 210.225L174.28 211.468C173.558 212.068 172.39 213.355 172.325 214.249C172.309 214.474 172.367 214.645 172.512 214.81C173.48 215.513 180.843 214.013 187.098 212.158L187.557 213.703C187.521 213.713 184.014 214.749 180.365 215.565C177.074 216.297 175.003 216.562 173.667 216.562H173.664Z"
        fill="#101052"
      />
      <path
        d="M119.472 280.061L110.29 337.189H11.947L31.2046 280.9L119.472 280.061Z"
        fill="#3A3A94"
      />
      <path
        d="M77.1918 304.774V337.189H66.103L77.1918 304.774Z"
        fill="#101052"
      />
      <path
        d="M66.8678 337.45L65.3418 336.928L76.5531 304.149L87.1578 300.306L90.3648 292.018L91.8715 292.599L88.3967 301.571L77.8307 305.4L66.8678 337.45Z"
        fill="#E4E8F0"
      />
      <path
        d="M39.8444 309.553H27.7556V307.939H39.8444C48.636 307.939 56.4242 302.664 59.686 294.502L60.8022 291.708L62.2993 292.308L61.183 295.102C57.6728 303.881 49.2974 309.553 39.8412 309.553H39.8444Z"
        fill="#E4E8F0"
      />
      <path
        d="M37.1768 308.76L28.5498 336.908L30.0921 337.381L38.7191 309.233L37.1768 308.76Z"
        fill="#E4E8F0"
      />
      <path
        d="M109.29 228.421C120.278 228.421 129.186 219.513 129.186 208.525C129.186 197.536 120.278 188.629 109.29 188.629C98.3015 188.629 89.3936 197.536 89.3936 208.525C89.3936 219.513 98.3015 228.421 109.29 228.421Z"
        fill="#101052"
      />
      <path
        d="M40.7675 189.493L78.8536 179.766L99.305 183.341L115.02 189.471L127.47 200.701L122.921 217.494L119.472 280.061L31.2048 280.9L25.1426 217.494L40.7675 189.493Z"
        fill="#101052"
      />
      <path
        d="M110.978 337.996H10.821L30.6272 280.1L120.421 279.248L110.978 337.999V337.996ZM13.0763 336.382H109.603L118.524 280.878L31.7822 281.7L13.0763 336.382Z"
        fill="#E4E8F0"
      />
      <path
        d="M52.4109 233.522L37.0571 262.827L32.7306 337.189H20.4224L26.7716 293.86L28.2332 280.9L29.4074 259.065L52.4109 233.522Z"
        fill="#101052"
      />
      <path
        d="M46.5746 228.421C57.5631 228.421 66.471 219.513 66.471 208.525C66.471 197.536 57.5631 188.629 46.5746 188.629C35.5861 188.629 26.678 197.536 26.678 208.525C26.678 219.513 35.5861 228.421 46.5746 228.421Z"
        fill="#101052"
      />
      <path
        d="M28.8107 199.559L5.47175 244.898C1.87768 251.883 0 259.623 0 267.479L1.22277 337.189H28.8462L31.6402 261.145L59.5731 220.62L28.8107 199.556V199.559Z"
        fill="#FFCBCB"
      />
      <path
        d="M29.1043 330.22L27.1364 330.256C25.5135 330.33 23.9617 330.952 22.7357 332.02L22.4291 332.288L22.071 320.703L22.4679 320.993C23.7777 321.954 25.3747 322.445 27.0007 322.384L29.4367 322.3L29.1043 330.22Z"
        fill="#F5167A"
      />
      <path
        d="M1.17774 330.662L2.09411 330.672C3.72015 330.691 5.29129 331.262 6.55276 332.288L6.86893 332.546L6.83349 320.954L6.44627 321.257C5.16867 322.264 3.5879 322.806 1.96509 322.8H0.993896L1.17774 330.662Z"
        fill="#F5167A"
      />
      <path
        d="M6.79814 322.716C6.72716 322.955 6.69165 323.206 6.69165 323.458L6.7271 329.994C6.73032 330.675 7.00128 331.317 7.48845 331.798C7.97562 332.282 8.62091 332.546 9.30166 332.543L19.8581 332.488C20.9744 332.482 21.9777 331.73 22.3003 330.656C22.3713 330.414 22.4068 330.165 22.4068 329.914L22.3714 323.377C22.3649 321.964 21.2099 320.822 19.7968 320.829L9.24038 320.883C8.12409 320.89 7.12077 321.642 6.79814 322.716Z"
        fill="#101052"
      />
      <path
        d="M12.3367 322.85L11.2498 324.042L17.348 329.603L18.4349 328.411L12.3367 322.85Z"
        fill="#E4E8F0"
      />
      <path
        d="M11.0762 325.325L9.98926 326.517L12.8405 329.117L13.9274 327.925L11.0762 325.325Z"
        fill="#E4E8F0"
      />
      <path
        d="M29.7882 197.846L12.918 230.431L38.7186 251.76L61.1991 220.272L29.7882 197.846Z"
        fill="#101052"
      />
      <path
        d="M56.0703 227.452L37.6494 250.895L38.9178 251.891L57.3387 228.449L56.0703 227.452Z"
        fill="#E4E8F0"
      />
      <path
        d="M92.5038 198.795H90.8906V221.937H92.5038V198.795Z"
        fill="#E4E8F0"
      />
      <path
        d="M87.8612 206.909C86.7772 206.909 85.8965 206.028 85.8965 204.944C85.8965 203.86 86.7772 202.979 87.8612 202.979C88.9453 202.979 89.826 203.86 89.826 204.944C89.826 206.028 88.9453 206.909 87.8612 206.909ZM87.8612 204.589C87.6677 204.589 87.5096 204.747 87.5096 204.941C87.5096 205.134 87.6677 205.292 87.8612 205.292C88.0548 205.292 88.2128 205.134 88.2128 204.941C88.2128 204.747 88.0548 204.589 87.8612 204.589Z"
        fill="#E4E8F0"
      />
      <path
        d="M87.8612 213.987C86.7772 213.987 85.8965 213.106 85.8965 212.022C85.8965 210.938 86.7772 210.057 87.8612 210.057C88.9453 210.057 89.826 210.938 89.826 212.022C89.826 213.106 88.9453 213.987 87.8612 213.987ZM87.8612 211.667C87.6677 211.667 87.5096 211.825 87.5096 212.019C87.5096 212.213 87.6677 212.371 87.8612 212.371C88.0548 212.371 88.2128 212.213 88.2128 212.019C88.2128 211.825 88.0548 211.667 87.8612 211.667Z"
        fill="#E4E8F0"
      />
      <path
        d="M103.702 156.711C103.702 156.711 98.2949 178.995 99.3531 189.248C100.408 199.501 89.642 198.785 89.642 198.785C89.642 198.785 68.6808 197.669 78.3855 180.837C78.3855 180.837 84.4509 163.199 84.5154 152.407L103.702 156.711Z"
        fill="#FFCBCB"
      />
      <path
        d="M101.944 164.641L100.26 174.494C100.115 174.459 99.9693 174.42 99.8242 174.381C93.4329 172.636 88.6612 167.293 87.432 160.786L87.1062 159.063L101.944 164.641Z"
        fill="#101052"
      />
      <path
        d="M98.4597 165.687C104.122 167.225 110.458 165.674 109.878 159.482C108.984 149.984 107.709 138.934 106.274 134.034C103.506 124.59 90.3521 131.275 90.3521 131.275C90.3521 131.275 81.6444 148.987 83.8866 154.169C87.8033 163.218 98.4597 165.687 98.4597 165.687Z"
        fill="#FFCBCB"
      />
      <path
        d="M82.9893 152.856C81.9118 149.242 81.6312 145.451 81.6473 141.696C81.6635 138.26 81.3215 135.195 82.6217 131.937C83.1282 130.665 83.8121 129.401 84.9284 128.607C86.0447 127.813 87.6837 127.623 88.7516 128.478C91.1519 125.397 94.9234 123.426 98.8239 123.213C103.776 122.942 113.984 127.016 111.232 133.608C109.471 137.828 104.518 136.102 101.444 134.569C99.9725 133.837 98.1884 133.208 96.7398 133.985C96.2784 134.234 95.8945 134.608 95.5493 134.998C94.2426 136.473 93.5748 137.986 93.2909 139.87C93.107 141.099 92.9553 143.074 92.0552 144.029C91.7713 144.329 91.2938 144.484 90.9389 144.274C89.7807 143.587 90.6357 140.87 90.7003 139.854C90.7745 138.683 90.5227 137.36 89.5548 136.695C88.3418 141.141 87.2577 145.622 86.3092 150.133C85.9898 151.656 85.6543 153.24 84.6961 154.466C84.0024 155.353 83.4217 154.308 82.9893 152.859V152.856Z"
        fill="#101052"
      />
      <path
        d="M101.17 138.789C101.073 139.47 101.344 140.07 101.77 140.131C102.199 140.192 102.621 139.689 102.718 139.008C102.815 138.328 102.544 137.728 102.118 137.666C101.689 137.605 101.266 138.108 101.17 138.789Z"
        fill="#101052"
      />
      <path
        d="M106.128 139.809C106.274 139.373 106.861 139.302 107.106 139.692C107.106 139.692 108.858 142.193 111.181 147.548C111.578 148.465 110.848 149.436 109.903 149.104L106.061 147.755C104.702 147.281 103.98 145.803 104.435 144.438L106.132 139.805L106.128 139.809Z"
        fill="#EB8D90"
      />
      <path
        d="M90.8649 138.173C90.8649 138.173 88.7357 132.85 85.7675 136.234C82.7993 139.615 80.5247 143.654 83.1413 145.861C85.7578 148.065 89.6519 146.952 89.6519 146.952L90.8681 138.176L90.8649 138.173Z"
        fill="#FFCBCB"
      />
      <path
        d="M86.505 140.071L85.7136 141.477L88.1932 142.873L88.9846 141.467L86.505 140.071Z"
        fill="#101052"
      />
      <path
        d="M121.635 229.678L118.784 280.043L120.394 280.135L123.245 229.769L121.635 229.678Z"
        fill="#E4E8F0"
      />
      <path
        d="M177.803 226.318L176.277 225.799L178.648 218.804L179.161 218.749C184.062 218.236 185.746 216.9 186.295 215.868C186.869 214.79 186.337 213.768 186.314 213.726L186.066 213.261L186.388 212.842C186.859 212.248 187.03 211.719 186.905 211.235C186.672 210.325 185.462 209.632 185.014 209.441L183.859 208.948L184.785 208.102C185.824 207.157 186.301 206.251 186.201 205.415C186.033 204.015 184.34 203.069 184.324 203.063L183.614 202.673L184.004 201.963C185.14 199.911 185.324 197.907 184.572 195.839C184.569 195.826 183.907 194.678 175.974 196.472C171.631 197.456 167.356 198.824 167.315 198.837L166.35 199.146L166.263 198.14C165.388 188.029 162.514 181.818 162.485 181.757L163.943 181.069C164.062 181.324 166.785 187.206 167.776 197.004C169.302 196.539 172.435 195.62 175.606 194.901C184.02 192.997 185.624 194.026 186.085 195.288C186.914 197.559 186.801 199.84 185.753 202.079C186.495 202.637 187.617 203.711 187.801 205.212C187.937 206.325 187.546 207.428 186.64 208.502C187.34 208.974 188.188 209.741 188.469 210.829C188.692 211.693 188.514 212.574 187.94 213.452C188.163 214.107 188.401 215.323 187.734 216.597C186.721 218.543 184.065 219.785 179.842 220.298L177.8 226.318H177.803Z"
        fill="#101052"
      />
      <path
        d="M107.886 149.704C109.154 149.768 110.287 150.559 110.739 151.746C110.942 152.285 111.019 152.853 110.781 153.34C110.09 154.75 97.256 153.365 97.256 153.365C97.256 153.365 96.5203 149.123 107.886 149.704Z"
        fill="#101052"
      />
      <line
        x1="595.1"
        y1="336.119"
        x2="31.9001"
        y2="336.119"
        stroke="#101052"
        stroke-width="1.2375"
      />
    </g>
    <defs>
      <clipPath id="clip0_2446_234607">
        <rect width="627" height="336.6" fill="white" />
      </clipPath>
    </defs>
  </svg>
))
